import React, { useState } from 'react'

// components
import Heading from '../../../components/text/Heading/Heading.component'

// collections
import EquipmentSearchListWithSearch from './collections/EquipmentSearchWithList.collection'

// forms
import CreateEquipmentFormController from './forms/CreateEquipment.form.controller'

//apollo
import { GET_ALL_EQUIPMENT_WITH_FULL_DETAIL } from '../../../graphql/equipment/equipment.queries';

//wrappers
import  WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper';

// mui
import { Typography, Container, Grid } from '@mui/material';

export default function EquipmentList({ ...pageProps }) {
    // modals
    const [showAdd, setShowAdd] = useState(false)

    return (<div id="Equipment">
        <CreateEquipmentFormController 
            visible={showAdd}
            closeForm={() => setShowAdd(false)}
        />

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}><Typography variant="h2">Equipment</Typography></Grid>
            </Grid>
        </Container>

        <WithGqlQuery
            component={EquipmentSearchListWithSearch}
            query={GET_ALL_EQUIPMENT_WITH_FULL_DETAIL}
            onAddClick={() => setShowAdd(true)}
            fetchPolicy={"network-only"}
            pageProps={pageProps}
        />   
    </div>)
}